module.exports = __webpack_public_path__ + "img/slide12.13aedf7b.png";